import { useMemo } from 'react'
import { type ThemeConfig } from 'antd'
import { type IMSTheme } from '@choreograph/layout'

/* substitution for `useAntdThemeConfig` from @choreograph/layout  */

export const useAntdThemeConfig = ({ colours, font, borderRadius }: IMSTheme, themeConfig?: ThemeConfig) =>
  useMemo(() => ({
    hashed: false,
    token: {
      fontFamily: font?.family,
      fontSize: 14, // font?.size, todo: check why WppOS theme has fontSize: 13
      colorLink: colours?.primary,
      colorPrimary: colours?.primary,
      borderRadius,
    },
    ...themeConfig
  }), [colours?.primary, font, borderRadius, themeConfig])
